import { Avatar } from '@picsart/design-system/components/Avatar';
import { IconLogout } from '@picsart/design-system/foundation/icons/IconLogout';
import { IconCoins } from '@picsart/design-system/foundation/icons/IconCoins';
import { IconChevronRight } from '@picsart/design-system/foundation/icons/IconChevronRight';
import { IconSettings } from '@picsart/design-system/foundation/icons/IconSettings';
import { IconAccounts } from '@picsart/design-system/foundation/icons/IconAccounts';
import type { BadgeTypes } from '@picsart/design-system/components/Badge';
import useStyles from './styles';

interface UserMenuContentProps {
  isAuthorized: boolean;
  username: string;
  avatarSrc?: string;
  avatarBadge?: BadgeTypes;
  credits: number | null;
  onCreditsClick: () => void;
  onSettingsClick?: () => void;
  onLogout: () => void;
  onSignIn: () => void;
}

export const UserMenuContent = ({
  isAuthorized,
  username,
  avatarSrc,
  avatarBadge,
  credits,
  onCreditsClick,
  onSettingsClick,
  onLogout,
  onSignIn,
}: UserMenuContentProps) => {
  const classes = useStyles();

  return (
    <>
      {isAuthorized && (
        <div className={classes.userCard}>
          <Avatar size={44} imageSrc={avatarSrc} badge={avatarBadge} />
          <div className={classes.userInfo}>
            <span className={classes.userName}>{username}</span>
            <span className={classes.userHandle}>@{username}</span>
          </div>
        </div>
      )}

      <div className={classes.menuSection}>
        {isAuthorized && credits !== null && (
          <button
            type="button"
            className={classes.menuItem}
            onClick={onCreditsClick}
            data-testid="genai-user-menu-open-credits"
          >
            <IconCoins fill="currentColor" className={classes.menuItemIcon} />
            <span className={classes.menuItemContent}>Credits</span>
            <span className={classes.menuItemEnd}>
              <span className={classes.creditsValue}>
                {credits.toLocaleString()}
              </span>
              <IconChevronRight fill="currentColor" width={16} height={16} />
            </span>
          </button>
        )}

        {onSettingsClick && (
          <button
            type="button"
            className={classes.menuItem}
            onClick={onSettingsClick}
            data-testid="genai-user-menu-settings"
          >
            <IconSettings
              fill="currentColor"
              className={classes.menuItemIcon}
            />
            <span className={classes.menuItemContent}>Settings</span>
            <span className={classes.menuItemEnd}>
              <IconChevronRight fill="currentColor" width={16} height={16} />
            </span>
          </button>
        )}

        {isAuthorized ? (
          <button
            type="button"
            className={classes.menuItem}
            onClick={onLogout}
            data-testid="genai-user-menu-logout"
          >
            <IconLogout fill="currentColor" className={classes.menuItemIcon} />
            <span className={classes.menuItemContent}>Log out</span>
          </button>
        ) : (
          <button
            type="button"
            className={classes.menuItem}
            onClick={onSignIn}
            data-testid="genai-user-menu-sign-in"
          >
            <IconAccounts
              fill="currentColor"
              className={classes.menuItemIcon}
            />
            <span className={classes.menuItemContent}>Sign in</span>
          </button>
        )}
      </div>
    </>
  );
};
